import { FC } from 'react';
import { Button, Menu } from 'react-daisyui';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { useTranslation } from 'react-i18next';
import { navData } from '@/layouts/Default/config-nav.tsx';
import { usePathname } from '@/hooks/usePathname.ts';
import { Link } from 'react-router-dom';
import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/24/solid';

type NavbarProps = {
  onClick?: () => void;
  menuClassName?: string;
};

const Navbar: FC<PropsWithClassName<NavbarProps>> = ({ className, onClick, menuClassName }) => {
  const { logout } = useAuthContext();
  const { t } = useTranslation();
  const pathname = usePathname();

  return (
    <nav className={cn('flex flex-col gap-4 justify-between grow', className)}>
      <div className="flex flex-col grow gap-6">
        <Menu className={cn('p-0 overflow-auto flex-nowrap grow h-1', menuClassName)}>
          {navData.map((item) => {
            const isActivated = item.path === pathname;

            return (
              <Menu.Item key={item.path}>
                <Link
                  to={item.path}
                  title={t(item.title)}
                  onClick={() => (onClick ? onClick() : null)}
                  className={cn(
                    'active:bg-black active:bg-opacity-40 hover:bg-black hover:bg-opacity-20 hover:text-[white] flex gap-2',
                    {
                      'bg-black bg-opacity-40 text-[white]': isActivated,
                    }
                  )}
                >
                  {item.icon ? <div className="w-4 h-4">{item.icon}</div> : null}
                  <span className="text-ellipsis line-clamp-1">{t(item.title)}</span>
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
      <div className="flex flex-col">
        <Button
          onClick={logout}
          color="ghost"
          className="!gap-4"
          startIcon={<ArrowLeftStartOnRectangleIcon className="w-4" />}
        >
          {t('button.logout')}
        </Button>
      </div>
    </nav>
  );
};

export default Navbar;
